<div [id]="idDragBtns" class="btn-group dragbtns" *ngIf="showDragButtons">
  <button type="button" class="btn btn-default btn-xs btn-circle btndrag" *ngIf="isopen" (click)="settingDiv()">
    <span class="far fa-eye-slash" title="hide modal"></span>&nbsp;
  </button>
  <button type="button" class="btn btn-default btn-xs btn-circle btndrag" *ngIf="!isopen" (click)="settingDiv()">
    <span class="far fa-eye" title="show modal"></span>&nbsp;
  </button>
  <button type="button" class="btn btn-default btn-xs btn-circle btndrag" (click)="close();">
    <span class="fas fa-times-circle" title="close modal"></span>&nbsp;
  </button>
</div>

<div [id]="idDragDiv" class="dragdiv">
  <div [id]="idDragDivHeader" class="dragdivheader">
    <strong>{{modalTitle}}</strong>
    <i class="fas fa-times float-right mr-3 q-pointer" (click)="close()"></i>
  </div>
  <div class="dragdivbody">
    <div class="bodyoverflowfixer">
      <ng-content></ng-content>
    </div>
  </div>
</div>
